module.exports = __webpack_public_path__ + "static/media/hyundai-minus.91cc4ca6.svg";